var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/facebook"
  }, /*#__PURE__*/React.createElement("g", {
    id: "facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M33 24.285C33 29.745 29.745 33 24.285 33H22.5C21.675 33 21 32.325 21 31.5V22.845C21 22.44 21.33 22.095 21.735 22.095L24.375 22.05C24.585 22.035 24.765 21.885 24.81 21.675L25.335 18.81C25.38 18.54 25.17 18.285 24.885 18.285L21.69 18.33C21.27 18.33 20.94 18 20.925 17.595L20.865 13.92C20.865 13.68 21.06 13.47 21.315 13.47L24.915 13.41C25.17 13.41 25.365 13.215 25.365 12.96L25.305 9.35999C25.305 9.10499 25.11 8.91 24.855 8.91L20.805 8.97002C18.315 9.01502 16.335 11.055 16.38 13.545L16.455 17.67C16.47 18.09 16.14 18.42 15.72 18.435L13.92 18.465C13.665 18.465 13.47 18.66 13.47 18.915L13.515 21.765C13.515 22.02 13.71 22.215 13.965 22.215L15.765 22.185C16.185 22.185 16.515 22.515 16.53 22.92L16.665 31.47C16.68 32.31 16.005 33 15.165 33H11.715C6.255 33 3 29.745 3 24.27V11.715C3 6.255 6.255 3 11.715 3H24.285C29.745 3 33 6.255 33 11.715V24.285Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook_icon.eb24f5a05075ae775148ba3897cdafc9.svg";
export { ForwardRef as ReactComponent };